import React from 'react'
import NextImage from 'next/image'
import { openOrInstallApp } from '@/utils/openOrInstallApp'
import type { IGlobalProps } from '@/types/cinematics'
import classes from './styles.module.scss'

interface IAppRedirectContentProps {
  /** Store keys to show, resolved against the global `props.stores`. */
  storeKeys: string[]
  stores?: IGlobalProps['stores']
}

/** Store badges (Google Play / App Store) that send the user to the app.
 *  Redirect today; deep-link later (behind `openOrInstallApp`). */
export const AppRedirectContent: React.FC<IAppRedirectContentProps> = ({ storeKeys, stores }) => {
  const badges = storeKeys
    .map((key) => stores?.find((store) => store.key === key))
    .filter((store): store is NonNullable<typeof store> => Boolean(store?.image))

  if (!badges.length) return null

  return (
    <div className={classes.stores}>
      {badges.map((store) => (
        <button
          key={store.key}
          type="button"
          aria-label={store.key}
          className={classes.store}
          onClick={() => openOrInstallApp(store)}
        >
          <NextImage src={store.image} alt={store.key} width={140} height={40} />
        </button>
      ))}
    </div>
  )
}
